module.exports = "https://cdn.littlereply.com/tt/resource/icon_account_selected.484444da7eae0c01f7b7d556084a0d04.png";